import React, { useMemo, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { EMAIL_API_URL, SITE } from "../utils/auth";
import "../../css/LoginPage.css";
import SEO from "../utils/SEO";

export default function ResetPasswordPage() {
  const { uid, token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [complete, setComplete] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const passwordReady = useMemo(() => {
    return password.length >= 8 && password === confirmPassword;
  }, [password, confirmPassword]);

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");
    setMessage("");

    if (password.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }

    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(`${EMAIL_API_URL}/reset-password-confirm/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ uid, token, password, site: SITE }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.detail || "Unable to create password.");
      setComplete(true);
      setMessage("Password created. Your portal link email is on the way, and you can sign in now.");
      setPassword("");
      setConfirmPassword("");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <SEO title="Create Password | SCD Partner Portal" description="Create your SCD Partner Portal password after being hired." path="/set-password" noindex />
      <div className="login-page">
        <div className="login-card password-setup-card">
          <div className="login-brand-mark">SCD</div>
          <h1>{complete ? "Password Created" : "Create Your Password"}</h1>
          <p className="login-subtitle">
            {complete
              ? "Your SCD Partner Portal account is ready."
              : "You have been invited to the SCD Partner Portal. Create your password to access onboarding and partner tools."}
          </p>

          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}

          {!complete ? (
            <form onSubmit={handleSubmit}>
              <div>
                <label>New Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  minLength="8"
                  autoComplete="new-password"
                />
              </div>
              <div>
                <label>Confirm Password</label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  minLength="8"
                  autoComplete="new-password"
                />
              </div>
              <p className="password-hint">Use at least 8 characters. Both fields must match.</p>
              <button type="submit" disabled={loading || !passwordReady}>{loading ? "Saving..." : "Create Password"}</button>
            </form>
          ) : (
            <button type="button" onClick={() => navigate("/")}>Go to Login</button>
          )}

          <div className="login-footer"><Link to="/">Back to login</Link></div>
        </div>
      </div>
    </>
  );
}
